import { useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { Button, Input, Loader, Modal, Segment, SegmentGroup, Table } from "semantic-ui-react";
import { toast } from "../..";
import { createExaminationOrganization } from "../../api/examinationOrganizations";
import {
    IExaminationOrganization,
    InitIExaminationOrganization,
} from "../../models/examinationOrganization";
import { fetchExaminationOrganizations } from "../../store/examinationOrganizationsReducer";
import { ExaminationOrganizationsRow } from "./ExaminationOrganizationsRow";

interface Props {
    examinationOrganizations: IExaminationOrganization[];
    examinationCount: number;
}

export const ExaminationOrganizationsView = ({
    examinationOrganizations,
    examinationCount,
}: Props) => {
    const intl = useIntl();
    const [loading, setLoading] = useState(false);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const dispatch = useDispatch();
    const [newExaminationOrganization, setNewExaminationOrganization] =
        useState<IExaminationOrganization>(InitIExaminationOrganization);

    const handleCreateNewPaymentTaype = async () => {
        try {
            setLoading(true);
            await createExaminationOrganization(newExaminationOrganization);
            toast(intl.formatMessage({ id: "examinationCreted" }), false);
        } catch {
            toast(intl.formatMessage({ id: "unableToCreateExamination" }), false);
        } finally {
            setCreateModalOpen(false);
            fetchExaminationOrganizations(dispatch);
            setLoading(false);
        }
    };

    return (
        <div className="examination-table-container">
            <h1>{intl.formatMessage({ id: "examinationOrganisation" })}</h1>
            <SegmentGroup>
                <Segment className="container-for-buttons">
                    <Button
                        primary
                        onClick={() => setCreateModalOpen(true)}
                        content={intl.formatMessage({ id: "createExamination" })}
                    />
                </Segment>
                {loading ? (
                    <Loader active inline="centered" size="huge" />
                ) : (
                    <Segment>
                        <Table basic="very" compact="very">
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell></Table.HeaderCell>
                                    <Table.HeaderCell></Table.HeaderCell>
                                    <Table.HeaderCell></Table.HeaderCell>
                                    <Table.HeaderCell></Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                <Table.Body>
                                    {examinationOrganizations.map((item, rowIndex) => (
                                        <ExaminationOrganizationsRow
                                            key={item.guid}
                                            examination={item}
                                            examinationCount={examinationCount}
                                            rowIndex={rowIndex}
                                        />
                                    ))}
                                </Table.Body>
                            </Table.Body>
                        </Table>
                    </Segment>
                )}
            </SegmentGroup>
            <Modal
                open={createModalOpen}
                closeIcon
                onClose={() => setCreateModalOpen(false)}
                dimmer="blurring"
                size="tiny"
            >
                <Modal.Content className="edit-modal">
                    <form className="add-user-form">
                        <section className="input-container">
                            <label>{intl.formatMessage({ id: "examinationOrganization" })}</label>
                            <Input
                                value={newExaminationOrganization.name}
                                onChange={(e: any) =>
                                    setNewExaminationOrganization({
                                        ...newExaminationOrganization,
                                        name: e.target.value,
                                    })
                                }
                            />
                        </section>
                    </form>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        content={intl.formatMessage({ id: "createExamination" })}
                        disabled={!newExaminationOrganization.name}
                        primary
                        onClick={handleCreateNewPaymentTaype}
                        fluid
                    />
                </Modal.Actions>
            </Modal>
        </div>
    );
};
